var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card flex-grow-1 shadow-sm"},[_c('div',{staticClass:"card-header"},[_vm._v("Monthly Subscribed")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.count))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb828ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/MonthlySubscribedCountComponent.vue
// module id = null
// module chunks = 